export const NotPurchased = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 12 12"
    fill="none"
  >
    <g clipPath="url(#clip0_6252_5573)">
      <path
        d="M5 11.5C5 11.776 4.776 12 4.5 12H2.5C1.1215 12 0 10.8785 0 9.5V2.5C0 1.1215 1.1215 0 2.5 0H6.5C7.8785 0 9 1.1215 9 2.5V3.5C9 3.776 8.776 4 8.5 4C8.224 4 8 3.776 8 3.5V2.5C8 1.673 7.327 1 6.5 1H2.5C1.673 1 1 1.673 1 2.5V9.5C1 10.327 1.673 11 2.5 11H4.5C4.776 11 5 11.224 5 11.5ZM7 3C7 2.724 6.776 2.5 6.5 2.5H2.5C2.224 2.5 2 2.724 2 3C2 3.276 2.224 3.5 2.5 3.5H6.5C6.776 3.5 7 3.276 7 3ZM2.5 7.5C2.224 7.5 2 7.724 2 8C2 8.276 2.224 8.5 2.5 8.5H3.5C3.776 8.5 4 8.276 4 8C4 7.724 3.776 7.5 3.5 7.5H2.5ZM12 8.5C12 10.43 10.43 12 8.5 12C6.57 12 5 10.43 5 8.5C5 6.57 6.57 5 8.5 5C10.43 5 12 6.57 12 8.5ZM11 8.5C11 7.1215 9.8785 6 8.5 6C7.1215 6 6 7.1215 6 8.5C6 9.8785 7.1215 11 8.5 11C9.8785 11 11 9.8785 11 8.5ZM8.5 6.5C8.086 6.5 7.75 6.836 7.75 7.25C7.75 7.664 8.086 8 8.5 8C8.914 8 9.25 7.664 9.25 7.25C9.25 6.836 8.914 6.5 8.5 6.5ZM8.5 8.5C8.224 8.5 8 8.724 8 9V10C8 10.276 8.224 10.5 8.5 10.5C8.776 10.5 9 10.276 9 10V9C9 8.724 8.776 8.5 8.5 8.5ZM5 5.5C5 5.224 4.776 5 4.5 5H2.5C2.224 5 2 5.224 2 5.5C2 5.776 2.224 6 2.5 6H4.5C4.776 6 5 5.776 5 5.5Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_6252_5573">
        <rect width="12" height="12" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
